import React from "react";
import { Link } from "react-router-dom";
import CdnImage from "../../../CdnImage";

const NoAgents = () => {
    return (
        <div className="w-100 row g-0 m-md-3" data-test="no-agents-found">
            <div className="col-md-6 g-0 p-3">
                <p className="h4">We were unable to find any agents.</p>
                <ul className="pt-2">
                    <li>
                        We will make sure any contact you submit is sent to an
                        agent in our network.
                    </li>
                    <li>
                        Try starting your property search on a state page, under
                        the Find navigation link above.
                    </li>
                    <li>
                        Return <Link to="/">Home</Link> to start your search
                        over.
                    </li>
                </ul>
            </div>
            <div className="col-md-6 g-0 mb-3">
                <CdnImage src="/no-agents.jpg" width="100%" />
            </div>
        </div>
    );
};

export default NoAgents;
